import { Box, Text, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { A11yCollapsibleCard, CollapseList, TaskListItem, ThemeAwareIcon, ToggleType, wdsThemeColors } from '@wix/rules-panel-ui';
import { StatusAlertFilledSmall } from '@wix/wix-ui-icons-common';
import React, { useCallback } from 'react';
import { BiCtaNames } from '../../../../bi/types';
import { useA11yWizardAdapter } from '../../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../../hooks/use-bi-logger';
import { useOpenArticleByEditorHost } from '../../../../hooks/use-open-article-by-editor-host';
import { WizardFooterManualTasks } from '../../../wizard-footer/wizard-footer-manual-tasks';
import { ManualTasksList } from '../manual-tasks';
export const ManualTasksCard = () => {
  const manualTasks = ManualTasksList();
  const {
    openSelectedArticle
  } = useOpenArticleByEditorHost();
  const biLogger = useBiLogger();
  const {
    capabilities,
    editorHost
  } = useA11yWizardAdapter();
  const compactPanelChrome = capabilities.compactPanelChrome;
  const {
    t
  } = useTranslation();
  const handleManualTasksToggle = useCallback((_id, isOpen) => {
    biLogger.wizardSectionExpandCollapse({
      cardName: 'manual-tasks',
      isAutomatic: false,
      issueCount: -1,
      pagesCount: -1,
      pagesWithIssueCount: -1,
      toggleType: isOpen ? ToggleType.Expand : ToggleType.Collapse
    });
  }, [biLogger]);
  return /*#__PURE__*/React.createElement(A11yCollapsibleCard, {
    "data-hook": "manual-tasks-card",
    flatCardSurface: compactPanelChrome,
    headerPadding: compactPanelChrome ? 'small' : 'medium',
    id: "manual-tasks",
    key: "manual-tasks",
    showBadge: false,
    showStickyHeaderSideShadow: !compactPanelChrome,
    title: t('accessibility-wizard.manual-tasks-card.title'),
    onToggle: handleManualTasksToggle
  }, /*#__PURE__*/React.createElement(CollapseList, {
    autoScroll: true,
    contentGap: 0
  }, manualTasks.map(task => /*#__PURE__*/React.createElement(TaskListItem, {
    id: task.title,
    key: task.title,
    prefix: /*#__PURE__*/React.createElement(ThemeAwareIcon, {
      color: wdsThemeColors.iconPrimary,
      height: "18px",
      verticalAlign: "middle",
      width: "18px"
    }, /*#__PURE__*/React.createElement(StatusAlertFilledSmall, null)),
    showBottomShadow: !compactPanelChrome,
    showTopShadow: !compactPanelChrome,
    title: task.title,
    variant: "collapsible"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    padding: compactPanelChrome ? 'SP3 SP4 SP4' : 'SP3 SP6 SP6'
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true
  }, task.description), task.articleKey && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(TextButton, {
    ariaLabel: task.ariaLabel,
    size: "tiny",
    skin: compactPanelChrome ? 'dark' : undefined,
    underline: "always",
    ellipsis: true,
    onClick: () => {
      biLogger.ctaClick({
        ctaName: `${BiCtaNames.ManualTask}-${task.ariaLabel}`
      });
      openSelectedArticle(editorHost, task.articleKey);
    }
  }, task.learnMore))))), /*#__PURE__*/React.createElement(WizardFooterManualTasks, {
    key: "wizard-footer-manual-tasks"
  })));
};
//# sourceMappingURL=manual-tasks-card.js.map